interface Env {
  VITE_API_URL: string
  VITE_CLERK_PUBLISHABLE_KEY: string
}

declare global {
  interface Window {
    // Set by /runtime-config.js in a deployed environment.
    __ARVOKE_CLERK_PUBLISHABLE_KEY__?: string
  }
}

// Checked by hand: a schema library for two strings would ride along in every
// page's first download.
function readEnv(): Env {
  // A deployed environment serves its own Clerk key when the page loads
  // (frontend/Caddyfile.web), so one web image signs in against the dev
  // instance in a PR environment and production's in production. Locally,
  // Vite's env provides it.
  const servedKey =
    typeof window === 'undefined' ? undefined : window.__ARVOKE_CLERK_PUBLISHABLE_KEY__
  const clerkPublishableKey = (servedKey || import.meta.env.VITE_CLERK_PUBLISHABLE_KEY)?.trim()
  if (!clerkPublishableKey) {
    throw new Error('VITE_CLERK_PUBLISHABLE_KEY is required')
  }
  return {
    VITE_API_URL: import.meta.env.VITE_API_URL || '/api/v1',
    VITE_CLERK_PUBLISHABLE_KEY: clerkPublishableKey,
  }
}

export const env: Env = readEnv()
